var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"habit-alternate-action"},[_c('explanation',{attrs:{"caption":"代わりの行動","description":"小さな行動ができないときの代わりの行動です。"}}),_c('input-alternate-action'),_c('button-set-alternate-action')],1)}
var staticRenderFns = []

export { render, staticRenderFns }